
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useState } from 'react';

export default function Playground() {
  const [activeCategory, setActiveCategory] = useState('all');

  // Today's date for display
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const categories = [
    { id: 'all', label: 'All Ideas', icon: 'ri-apps-line' },
    { id: 'holidays', label: 'Holidays', icon: 'ri-cake-3-line' },
    { id: 'trending', label: 'Trending', icon: 'ri-fire-line' },
    { id: 'history', label: 'History', icon: 'ri-time-line' },
    { id: 'business', label: 'Business', icon: 'ri-briefcase-line' },
  ];

  const featuredIdea = {
    category: 'Holiday',
    title: 'National Cupcake Day',
    subtitle: 'Sweet content ideas to celebrate today',
    description: 'National Cupcake Day is trending with over 2.3M mentions across social media. Our AI has generated 15 unique post ideas tailored to your brand voice.',
    image: 'https://images.unsplash.com/photo-1614707267537-b85aaf00c4b7?w=800&q=80',
    stats: {
      engagement: '+240%',
      reach: '2.3M',
      posts: '15 Ideas',
    },
    tags: ['Food & Beverage', 'Lifestyle', 'Celebration'],
  };

  const topBlurbs = [
    {
      title: 'This Day in History',
      subtitle: 'Top Instagram posts celebrating historical events today',
      image: 'https://images.unsplash.com/photo-1553531384-cc64ac80f931?w=400&q=80',
      engagement: '+320%'
    },
    {
      title: 'Significant event on this day',
      subtitle: 'Historical milestones that resonate with your audience',
      image: 'https://images.unsplash.com/photo-1531572753322-ad063cecc140?w=400&q=80',
      engagement: '+450%'
    },
    {
      title: 'Sustainability in 2025',
      subtitle: 'Eco-friendly posts getting 3x more engagement this week',
      image: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=400&q=80',
      engagement: '+290%'
    },
    {
      title: 'National Coffee Day',
      subtitle: 'Brew up engagement with coffee-themed content ideas',
      image: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=400&q=80',
      engagement: '+180%'
    },
  ];

  const contentIdeas = [
    {
      id: 1,
      category: 'holidays',
      type: 'Holiday',
      title: 'National Coffee Day',
      description: 'Brew up engagement with coffee-themed content ideas',
      image: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=600&q=80',
      engagement: '+180%',
      time: '2 hours ago',
      trending: true,
    },
    {
      id: 2,
      category: 'history',
      type: 'History',
      title: 'This Day in History',
      description: 'Top Instagram posts celebrating historical events today',
      image: 'https://images.unsplash.com/photo-1553531384-cc64ac80f931?w=600&q=80',
      engagement: '+320%',
      time: '1 hour ago',
      trending: true,
    },
    {
      id: 3,
      category: 'history',
      type: 'History',
      title: 'On This Day: The Eiffel Tower',
      description: 'In 1889, the iconic Eiffel Tower was completed in Paris',
      image: 'https://images.unsplash.com/photo-1511739001486-6bfe10ce785f?w=600&q=80',
      engagement: '+95%',
      time: '3 hours ago',
      trending: false,
    },
    {
      id: 4,
      category: 'business',
      type: 'Business',
      title: 'First iPhone Launch Anniversary',
      description: 'Apple revolutionized mobile phones 17 years ago today',
      image: 'https://images.unsplash.com/photo-1510557880182-3d4d3cba35a5?w=600&q=80',
      engagement: '+210%',
      time: '30 mins ago',
      trending: true,
    },
    {
      id: 5,
      category: 'trending',
      type: 'Trending',
      title: 'Sustainability in 2025',
      description: 'Eco-friendly posts getting 3x more engagement this week',
      image: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=600&q=80',
      engagement: '+290%',
      time: '45 mins ago',
      trending: true,
    },
    {
      id: 6,
      category: 'trending',
      type: 'Trending',
      title: 'Northern Lights Spectacular',
      description: 'Stunning aurora borealis photos captivating audiences worldwide',
      image: 'https://images.unsplash.com/photo-1579033461380-adb47c3eb938?w=600&q=80',
      engagement: '+150%',
      time: '4 hours ago',
      trending: false,
    },
    {
      id: 7,
      category: 'holidays',
      type: 'Holiday',
      title: 'International Women\'s Day',
      description: 'Empower your audience with inspiring women-led stories',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&q=80',
      engagement: '+275%',
      time: '5 hours ago',
      trending: true,
    },
    {
      id: 8,
      category: 'history',
      type: 'History',
      title: 'Significant event on this day',
      description: 'Historical milestones that resonate with your audience',
      image: 'https://images.unsplash.com/photo-1531572753322-ad063cecc140?w=600&q=80',
      engagement: '+450%',
      time: '15 mins ago',
      trending: true,
    },
    {
      id: 9,
      category: 'holidays',
      type: 'Holiday',
      title: 'World Book Day',
      description: 'Share your favorite reads and inspire your community',
      image: 'https://images.unsplash.com/photo-1495446815901-a7297e633e8d?w=600&q=80',
      engagement: '+135%',
      time: '6 hours ago',
      trending: false,
    },
    {
      id: 10,
      category: 'business',
      type: 'Business',
      title: 'Small Business Saturday Ideas',
      description: 'Support local campaigns seeing massive community engagement',
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&q=80',
      engagement: '+195%',
      time: '7 hours ago',
      trending: false,
    },
    {
      id: 11,
      category: 'trending',
      type: 'Trending',
      title: 'Behind-The-Scenes Content',
      description: 'Authentic BTS posts driving 3x higher save rates',
      image: 'https://images.unsplash.com/photo-1516321497487-e288fb19713f?w=600&q=80',
      engagement: '+380%',
      time: '20 mins ago',
      trending: true,
    },
    {
      id: 12,
      category: 'history',
      type: 'History',
      title: 'First Email Sent Anniversary',
      description: 'Communication revolution that changed business forever',
      image: 'https://images.unsplash.com/photo-1596526131083-e8c633c948d2?w=600&q=80',
      engagement: '+110%',
      time: '8 hours ago',
      trending: false,
    },
    {
      id: 13,
      category: 'holidays',
      type: 'Holiday',
      title: 'Mental Health Awareness Day',
      description: 'Wellness content resonating with 85% of audiences',
      image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&q=80',
      engagement: '+265%',
      time: '9 hours ago',
      trending: true,
    },
    {
      id: 14,
      category: 'trending',
      type: 'Trending',
      title: 'User-Generated Content Strategy',
      description: 'UGC campaigns increasing trust by 92%',
      image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=600&q=80',
      engagement: '+340%',
      time: '25 mins ago',
      trending: true,
    },
    {
      id: 15,
      category: 'business',
      type: 'Business',
      title: 'Customer Success Story Spotlight',
      description: 'Testimonial posts converting 4x better than standard ads',
      image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&q=80',
      engagement: '+225%',
      time: '10 hours ago',
      trending: false,
    },
    {
      id: 16,
      category: 'history',
      type: 'History',
      title: 'World Wide Web Anniversary',
      description: 'The day the internet became publicly accessible',
      image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&q=80',
      engagement: '+140%',
      time: '11 hours ago',
      trending: false,
    },
    {
      id: 17,
      category: 'holidays',
      type: 'Holiday',
      title: 'Earth Day Celebration',
      description: 'Green initiatives and sustainability posts trending worldwide',
      image: 'https://images.unsplash.com/photo-1511497584788-876760111969?w=600&q=80',
      engagement: '+310%',
      time: '12 hours ago',
      trending: true,
    },
    {
      id: 18,
      category: 'trending',
      type: 'Trending',
      title: 'Interactive Polls & Quizzes',
      description: 'Engagement-boosting interactive content formats',
      image: 'https://images.unsplash.com/photo-1434626881859-194d67b2b86f?w=600&q=80',
      engagement: '+395%',
      time: '35 mins ago',
      trending: true,
    },
    {
      id: 19,
      category: 'business',
      type: 'Business',
      title: 'Founder Story: From Idea to Launch',
      description: 'Entrepreneurship journeys inspiring massive engagement',
      image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=600&q=80',
      engagement: '+245%',
      time: '13 hours ago',
      trending: false,
    },
    {
      id: 20,
      category: 'holidays',
      type: 'Holiday',
      title: 'Pet Appreciation Day',
      description: 'Furry friends content always wins hearts and likes',
      image: 'https://images.unsplash.com/photo-1450778869180-41d0601e046e?w=600&q=80',
      engagement: '+420%',
      time: '14 hours ago',
      trending: true,
    },
  ];

  const trendingTopics = [
    { topic: 'Historical Events', mentions: '3.8M', growth: '+450%' },
    { topic: 'National Cupcake Day', mentions: '2.3M', growth: '+340%' },
    { topic: 'This Day in History', mentions: '1.2M', growth: '+320%' },
    { topic: 'User-Generated Content', mentions: '2.1M', growth: '+285%' },
    { topic: 'Sustainability', mentions: '890K', growth: '+245%' },
    { topic: 'Behind-The-Scenes', mentions: '1.6M', growth: '+190%' },
    { topic: 'Interactive Content', mentions: '1.4M', growth: '+175%' },
    { topic: 'Mental Health', mentions: '2.7M', growth: '+165%' },
  ];

  const spotlightStories = [
    {
      title: 'How Small Businesses Are Using AI to Compete',
      category: 'Business',
      image: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=400&q=80',
      reads: '12.5K',
    },
    {
      title: 'The Rise of Video Content in 2025',
      category: 'Trending',
      image: 'https://images.unsplash.com/photo-1492619375914-88005aa9e8fb?w=400&q=80',
      reads: '18.2K',
    },
    {
      title: 'Social Media Trends Every Marketer Should Know',
      category: 'Marketing',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&q=80',
      reads: '25.1K',
    },
    {
      title: '10 Ways to Boost Engagement with Interactive Content',
      category: 'Strategy',
      image: 'https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=400&q=80',
      reads: '9.8K',
    },
  ];

  const leftSidebarItems = [
    {
      icon: 'ri-calendar-event-line',
      title: 'Holiday Calendar',
      count: '12 Today',
      color: 'from-pink-500 to-rose-500'
    },
    {
      icon: 'ri-history-line',
      title: 'Historical Events',
      count: '24 Events',
      color: 'from-blue-500 to-indigo-500'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Business Milestones',
      count: '8 Today',
      color: 'from-green-500 to-emerald-500'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Viral Content',
      count: '89 Ideas',
      color: 'from-yellow-500 to-orange-500'
    },
  ];

  const filteredIdeas = activeCategory === 'all'
    ? contentIdeas
    : contentIdeas.filter(idea => idea.category === activeCategory);

  return (
    <div className="min-h-screen bg-gray-50 font-['Montserrat']">
      <Header />

      {/* Hero Section */}
      <section className="pt-24 pb-6 bg-gradient-to-br from-[#22577A] to-[#38a3a5]">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between mb-4">
            <div>
              <div className="inline-flex items-center px-4 py-2 bg-white/20 rounded-full text-white font-medium mb-3">
                <i className="ri-lightbulb-flash-line mr-2"></i>
                AI Creative Engine
              </div>
              <h1 className="text-4xl lg:text-5xl font-bold text-white mb-2">
                The Playground
              </h1>
              <p className="text-white/90 text-lg">
                {today}
              </p>
            </div>
            <div className="hidden md:block">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border-2 border-white/20">
                <div className="text-white/70 text-sm mb-1">Daily Ideas</div>
                <div className="text-4xl font-bold text-white">342</div>
              </div>
            </div>
          </div>

          {/* Category Tabs */}
          <div className="flex gap-3 overflow-x-auto pb-2">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`px-6 py-2 rounded-lg font-semibold whitespace-nowrap transition-all flex items-center gap-2 ${
                  activeCategory === cat.id
                    ? 'bg-white text-[#22577A] shadow-lg'
                    : 'bg-white/10 text-white hover:bg-white/20'
                }`}
              >
                <i className={cat.icon}></i>
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Sticky Trending Now Section - Yahoo Style */}
      <div className="sticky top-0 z-40 bg-white border-b-2 border-gray-200 shadow-md">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <div className="flex items-center gap-2 mb-3">
            <i className="ri-fire-line text-2xl text-orange-600"></i>
            <h3 className="text-lg font-bold text-[#22577A]">Trending Now</h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3">
            {trendingTopics.map((topic, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-lg p-3 hover:bg-gray-100 transition-colors cursor-pointer border border-gray-200"
              >
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs font-bold text-orange-600">#{index + 1}</span>
                  <span className="text-xs font-semibold text-gray-800 truncate">{topic.topic}</span>
                </div>
                <div className="text-xs text-green-600 font-semibold">
                  {topic.growth}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Top Blurbs Section - Yahoo Style */}
      <section className="py-4 bg-white border-b border-gray-200">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {topBlurbs.map((blurb, index) => (
              <div
                key={index}
                className="group cursor-pointer"
              >
                <div className="aspect-video rounded-lg overflow-hidden mb-2 bg-gray-100">
                  <img
                    src={blurb.image}
                    alt={blurb.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                  />
                </div>
                <h4 className="font-bold text-sm text-gray-800 mb-1 group-hover:text-[#22577A] transition-colors line-clamp-2">
                  {blurb.title}
                </h4>
                <p className="text-xs text-gray-600 line-clamp-1">{blurb.subtitle}</p>
                <div className="text-xs text-green-600 font-semibold mt-1">
                  {blurb.engagement} engagement
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Main 3-Column Layout - Yahoo Style */}
      <section className="py-6">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-12 gap-4">
            {/* Left Sidebar - 2 columns */}
            <div className="lg:col-span-2 space-y-4">
              {/* Quick Access Bubbles */}
              {leftSidebarItems.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl border-2 border-gray-200 p-4 hover:shadow-lg transition-all cursor-pointer group"
                >
                  <div className={`w-12 h-12 bg-gradient-to-br ${item.color} rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                    <i className={`${item.icon} text-white text-xl`}></i>
                  </div>
                  <h4 className="font-bold text-gray-800 text-sm mb-1">{item.title}</h4>
                  <p className="text-xs text-gray-600">{item.count}</p>
                </div>
              ))}

              {/* AI Info Box */}
              <div className="bg-gradient-to-br from-[#e4f4ff]/30 to-[#b3d9ff]/30 rounded-xl border-2 border-[#66b3ff]/30 p-4">
                <div className="w-10 h-10 bg-gradient-to-br from-[#22577A] to-[#38a3a5] rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-magic-line text-white text-xl"></i>
                </div>
                <h3 className="text-sm font-bold text-[#22577A] mb-2">
                  AI-Powered Ideas
                </h3>
                <p className="text-xs text-gray-700 mb-3 leading-relaxed">
                  Daily content ideas personalized to your brand.
                </p>
                <button className="w-full px-3 py-2 bg-gradient-to-r from-[#22577A] to-[#38a3a5] text-white rounded-lg font-semibold text-xs hover:shadow-lg transition-all">
                  Learn More
                </button>
              </div>

              {/* Quick Stats */}
              <div className="bg-white rounded-xl border-2 border-gray-200 p-4">
                <h3 className="text-sm font-bold text-[#22577A] mb-3">Today's Stats</h3>
                <div className="space-y-2">
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-gray-600">Ideas</span>
                    <span className="font-bold text-[#22577A]">342</span>
                  </div>
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-gray-600">Topics</span>
                    <span className="font-bold text-[#22577A]">58</span>
                  </div>
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-gray-600">Events</span>
                    <span className="font-bold text-[#22577A]">24</span>
                  </div>
                  <div className="flex items-center justify-between text-xs">
                    <span className="text-gray-600">Holidays</span>
                    <span className="font-bold text-[#22577A]">12</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Center Column - Main Content - 7 columns */}
            <div className="lg:col-span-7 space-y-4">
              {/* Featured Idea Card with Background */}
              <div className="relative rounded-xl border-2 border-pink-200 overflow-hidden hover:shadow-xl transition-all">
                {/* Background Image */}
                <div
                  className="absolute inset-0 bg-cover bg-center"
                  style={{
                    backgroundImage: "url('/assets/cupcake-celebration.jpg')",
                  }}
                >
                  {/* Light Overlay for text readability */}
                  <div className="absolute inset-0 bg-white/40"></div>
                </div>

                {/* Content */}
                <div className="relative p-6">
                  {/* Icon Header */}
                  <div className="flex items-center justify-between mb-6">
                    <span className="px-4 py-2 bg-white/95 backdrop-blur-sm rounded-full text-[#22577A] font-bold text-sm shadow-md flex items-center gap-2">
                      <i className="ri-star-fill text-yellow-500"></i>
                      Featured Idea
                    </span>
                  </div>

                  {/* Stats Grid */}
                  <div className="grid grid-cols-3 gap-4 mb-8 mt-32">
                    <div className="bg-white/95 backdrop-blur-md rounded-lg p-4 text-center shadow-lg">
                      <div className="text-[#22577A] font-bold text-xl">{featuredIdea.stats.engagement}</div>
                      <div className="text-[#22577A]/70 text-xs">Engagement</div>
                    </div>
                    <div className="bg-white/95 backdrop-blur-md rounded-lg p-4 text-center shadow-lg">
                      <div className="text-[#22577A] font-bold text-xl">{featuredIdea.stats.reach}</div>
                      <div className="text-[#22577A]/70 text-xs">Reach</div>
                    </div>
                    <div className="bg-white/95 backdrop-blur-md rounded-lg p-4 text-center shadow-lg">
                      <div className="text-[#22577A] font-bold text-xl">{featuredIdea.stats.posts}</div>
                      <div className="text-[#22577A]/70 text-xs">Generated</div>
                    </div>
                  </div>

                  {/* Content */}
                  <h2 className="text-3xl font-bold text-[#22577A] mb-2 drop-shadow-sm">
                    {featuredIdea.title}
                  </h2>
                  <p className="text-pink-600 font-semibold mb-4 text-lg drop-shadow-sm">
                    {featuredIdea.subtitle}
                  </p>
                  <p className="text-gray-800 mb-6 leading-relaxed font-medium drop-shadow-sm">
                    {featuredIdea.description}
                  </p>
                  <div className="flex flex-wrap gap-2 mb-6">
                    {featuredIdea.tags.map((tag, index) => (
                      <span
                        key={index}
                        className="px-3 py-1 bg-white/95 backdrop-blur-sm text-gray-700 rounded-full text-sm font-medium shadow-md"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <button className="w-full px-6 py-3 bg-gradient-to-r from-[#22577A] to-[#38a3a5] text-white rounded-lg font-semibold hover:shadow-lg transition-all flex items-center justify-center gap-2 shadow-lg">
                    <i className="ri-sparkling-line"></i>
                    Generate Content Ideas
                  </button>
                </div>
              </div>

              {/* Content Ideas Grid */}
              <div>
                <div className="flex items-center justify-between mb-4 bg-white rounded-xl border-2 border-gray-200 p-4">
                  <h3 className="text-xl font-bold text-[#22577A]">
                    {activeCategory === 'all' ? 'All Ideas' : categories.find(c => c.id === activeCategory)?.label}
                  </h3>
                  <span className="text-gray-600 font-medium text-sm">{filteredIdeas.length} ideas</span>
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                  {filteredIdeas.map((idea) => (
                    <div
                      key={idea.id}
                      className="bg-white rounded-xl border-2 border-gray-200 hover:border-[#66b3ff] hover:shadow-lg transition-all overflow-hidden cursor-pointer group"
                    >
                      {/* Image Header */}
                      <div className="h-40 relative bg-gray-100">
                        <img
                          src={idea.image}
                          alt={idea.title}
                          className="w-full h-full object-cover"
                        />
                        {idea.trending && (
                          <div className="absolute top-2 right-2">
                            <span className="px-2 py-1 bg-orange-500 text-white rounded-full text-xs font-bold flex items-center gap-1">
                              <i className="ri-fire-fill"></i>
                              Trending
                            </span>
                          </div>
                        )}
                        <div className="absolute top-2 left-2">
                          <span className="px-2 py-1 bg-white/90 backdrop-blur-sm rounded-full text-[#22577A] text-xs font-semibold uppercase">
                            {idea.type}
                          </span>
                        </div>
                      </div>

                      {/* Content */}
                      <div className="p-4">
                        <h4 className="font-bold text-[#22577A] group-hover:text-[#38a3a5] transition-colors mb-2 line-clamp-2">
                          {idea.title}
                        </h4>
                        <p className="text-gray-600 text-sm mb-3 leading-relaxed line-clamp-2">
                          {idea.description}
                        </p>
                        <div className="flex items-center justify-between text-xs border-t border-gray-100 pt-3">
                          <div className="flex items-center gap-3">
                            <span className="flex items-center gap-1 text-green-600 font-semibold">
                              <i className="ri-arrow-up-line"></i>
                              {idea.engagement}
                            </span>
                            <span className="text-gray-500">
                              <i className="ri-time-line mr-1"></i>
                              {idea.time}
                            </span>
                          </div>
                          <button className="text-[#22577A] hover:text-[#38a3a5] transition-colors font-semibold flex items-center gap-1">
                            View
                            <i className="ri-arrow-right-line"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Sidebar - 3 columns */}
            <div className="lg:col-span-3 space-y-4">
              {/* Spotlight Stories */}
              <div className="bg-white rounded-xl border-2 border-gray-200 p-4">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-bold text-[#22577A] flex items-center gap-2">
                    <i className="ri-flashlight-line text-yellow-500"></i>
                    Spotlight
                  </h3>
                  <a href="#more" className="text-[#38a3a5] hover:underline text-xs font-semibold">
                    See All
                  </a>
                </div>
                <div className="space-y-3">
                  {spotlightStories.map((story, index) => (
                    <div
                      key={index}
                      className="flex gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer group"
                    >
                      <div className="w-20 h-16 flex-shrink-0 rounded-lg overflow-hidden shadow-sm group-hover:scale-105 transition-transform bg-gray-100">
                        <img
                          src={story.image}
                          alt={story.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <span className="text-xs font-semibold text-[#38a3a5] uppercase mb-1 block">
                          {story.category}
                        </span>
                        <h4 className="font-bold text-sm text-gray-800 mb-1 group-hover:text-[#22577A] transition-colors line-clamp-2">
                          {story.title}
                        </h4>
                        <div className="flex items-center gap-2 text-xs text-gray-600">
                          <span className="flex items-center gap-1">
                            <i className="ri-eye-line"></i>
                            {story.reads}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Popular Categories */}
              <div className="bg-white rounded-xl border-2 border-gray-200 p-4">
                <h3 className="text-sm font-bold text-[#22577A] mb-3">Popular Categories</h3>
                <div className="space-y-2">
                  {categories.slice(1).map((cat) => (
                    <button
                      key={cat.id}
                      onClick={() => setActiveCategory(cat.id)}
                      className="w-full px-3 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left transition-colors flex items-center justify-between group"
                    >
                      <div className="flex items-center gap-2">
                        <i className={`${cat.icon} text-[#22577A]`}></i>
                        <span className="text-sm font-medium text-gray-800">{cat.label}</span>
                      </div>
                      <i className="ri-arrow-right-s-line text-gray-400 group-hover:text-[#22577A]"></i>
                    </button>
                  ))}
                </div>
              </div>

              {/* Weather-Style Box */}
              <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-4 text-white">
                <div className="flex items-center gap-3 mb-3">
                  <i className="ri-sun-line text-3xl"></i>
                  <div>
                    <div className="text-2xl font-bold">72°F</div>
                    <div className="text-xs opacity-90">Perfect posting!</div>
                  </div>
                </div>
                <p className="text-xs opacity-90 mb-3">
                  High engagement expected today.
                </p>
                <div className="grid grid-cols-3 gap-2 text-center text-xs">
                  <div className="bg-white/20 rounded-lg p-2">
                    <div>Mon</div>
                    <i className="ri-sun-line text-lg"></i>
                  </div>
                  <div className="bg-white/20 rounded-lg p-2">
                    <div>Tue</div>
                    <i className="ri-cloudy-line text-lg"></i>
                  </div>
                  <div className="bg-white/20 rounded-lg p-2">
                    <div>Wed</div>
                    <i className="ri-sun-line text-lg"></i>
                  </div>
                </div>
              </div>

              {/* CTA Box */}
              <div className="bg-gradient-to-br from-[#22577A] to-[#38a3a5] rounded-xl p-4 text-white">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-vip-crown-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-bold mb-2">
                  Unlock Premium
                </h3>
                <p className="text-sm opacity-90 mb-4">
                  Get unlimited AI ideas and advanced analytics.
                </p>
                <button className="w-full px-4 py-2 bg-white text-[#22577A] rounded-lg font-semibold hover:shadow-lg transition-all text-sm">
                  Start Free Trial
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
